export const API_BASE = process.env.REACT_APP_API_URL || '/api';

export function getSubdomain() {
  const host = window.location.hostname;
  const parts = host.split('.');
  if (parts.length >= 3) return parts[0];
  return null;
}

let tenantCache = null;

export async function resolveTenant() {
  if (tenantCache) return tenantCache;
  const subdomain = getSubdomain();
  if (!subdomain) return null;
  try {
    const res = await fetch(`${API_BASE}/tenants/by-subdomain/${subdomain}`);
    if (!res.ok) return null;
    tenantCache = await res.json();
    return tenantCache;
  } catch { return null; }
}

export async function publicApi(path, options = {}) {
  return fetch(`${API_BASE}${path}`, options).catch(() => ({ ok: false, json: () => Promise.resolve(null) }));
}

export function getPortalToken() {
  return localStorage.getItem('portalToken');
}

export function setPortalToken(token) {
  localStorage.setItem('portalToken', token);
}

export function clearPortalToken() {
  localStorage.removeItem('portalToken');
}

export async function portalApi(path, options = {}) {
  const token = getPortalToken();
  if (!token) return { ok: false };
  const sep = path.includes('?') ? '&' : '?';
  return fetch(`${API_BASE}${path}${sep}token=${token}`, options).catch(() => ({ ok: false, json: () => Promise.resolve(null) }));
}
